import classNames from 'classnames';
import { ComponentProps } from 'react';

export const DrawerContent = ({
    className,
    children,
    ...props
}: ComponentProps<'div'>) => (
    <div
        {...props}
        className={classNames(
            'drawer-body mb-4 drawer-lg:mb-6 pt-4 drawer-lg:pt-6 px-4 drawer-lg:px-6 border-t border-gray-200 overflow-auto',
            className
        )}
    >
        {children}
    </div>
);
